"use client";

import { ChartLine } from "lucide-react";
import { useTranslations } from "next-intl";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { ObservatoryStat } from "@/components";
import type { Observatory } from "@/types";

interface ObservatoryStatTimeserieProps extends HTMLAttributes<HTMLDivElement> {
  observatory: Observatory;
}

function ObservatoryStatTimeserie({
  observatory,
}: Readonly<ObservatoryStatTimeserieProps>): ReactElement | null {
  const t = useTranslations("global.ObservatoryStat");

  if (observatory.stat?.timeserie) {
    return (
      <ObservatoryStat
        number={observatory.stat.timeserie}
        label={t("timeserie", { count: observatory.stat.timeserie })}
        icon={<ChartLine strokeWidth={1} />}
      />
    );
  }

  return null;
}

export { ObservatoryStatTimeserie, type ObservatoryStatTimeserieProps };
